import { DASHBOARD_TABS } from '../TabEngine/tabDefinitions';
import { WS_DEFAULT_RK, WS_DEFAULT_TAB_ID, WS_TAB_PREFIX } from './workspaceConst';

/**
 * Maps workspaces to dashboard tabs and back. Every workspace tab renders the same
 * component as the default 'library' tab (YourLibraryTab).
 */
export default class WorkspaceTabBuilder {
    /**
     * @param {{rk: string, name: string}} snapshot
     * @returns {object} tab definition, same shape as DASHBOARD_TABS entries
     */
    static toTab(snapshot) {
        const library = DASHBOARD_TABS.find((t) => t.id === WS_DEFAULT_TAB_ID);
        return {
            id: WorkspaceTabBuilder.toTabId(snapshot.rk),
            label: snapshot.name,
            component: library?.component,
            scrollable: false,
            admin: false,
            workspaceRk: snapshot.rk,
        };
    }

    /**
     * @param {string} rk
     * @returns {string}
     */
    static toTabId(rk) {
        return rk === WS_DEFAULT_RK ? WS_DEFAULT_TAB_ID : `${WS_TAB_PREFIX}${rk}`;
    }

    /**
     * @param {object|null} tab
     * @returns {string|null} workspace rk, null when the tab is not a workspace
     */
    static toRk(tab) {
        if (!tab) return null;
        if (tab.workspaceRk) return tab.workspaceRk;
        return tab.id === WS_DEFAULT_TAB_ID ? WS_DEFAULT_RK : null;
    }
}
